
import BullBullConst from "../../utils/bullbull_const";
import BullCardValueCom from "./bull_card_value_com";


const {ccclass,property} = cc._decorator;

@ccclass
/**
 * 玩家自己牌的组件
 */
export default class CardSelfCom extends cc.Component{

    private _upState : boolean;
    public get upState() : boolean {
        return this._upState;
    }

    private initPos : cc.Vec2;


    start(){

        this._upState = false;

        this.initPos = this.node.position;

        //cc.log(" start CardSelfCom node ",this.name);
    }

    reset(){

        //cc.log("  CardSelfCom  reset " , this.name);
        if (!this.initPos) {
            return;
        }
        this.node.position = this.initPos;
        
        this._upState = false;

        this.node.stopAllActions();
    }

    onDisable(){

        this.reset();
    }

    public moveUp(){

        this.node.runAction(cc.moveBy(0.1,cc.v2(0,50)));  
        this._upState = true;
    }

    public moveDown(){

        this.node.runAction(cc.moveBy(0.1,cc.v2(0,-50)));    
        this._upState = false;
    }


    public getPokerNumber() : number {

        if (!this.upState) {
            return;
        }

        let sp = this.node.getComponent(cc.Sprite);

        let value_com = this.node.getComponent(BullCardValueCom);

        // let name = sp.spriteFrame.name;
        // if (name.length > 2) {
            
        //     name = name.substring(0,2);
            
        // }else{

        //     name = name.substring(0,1);
        // }

        //let value = BullBullConst.POKER_NUMBER_MAP[name];
        let value = value_com.cardValue;
        return value > 10 ? 10 : value;
        
    }


}

